// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/progress","root":"progress-m__root__2XHXH","output":"progress-m__output__vKJw-","bar":"progress-m__bar__sB2fc","progress":"progress-m__progress__2V0hS"};